import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Alert, Link, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProjectContext } from "../../contexts/ProjectContext";

export default function ProjectLockedBanner() {
  const navigate = useNavigate();
  const project = useContext(ProjectContext);

  const goProjectPermissions = useCallback(() => {
    if (project) {
      navigate(
        `/settings?settings=project-permissions&projectId=${project.id}`,
      );
    }
  }, [navigate, project]);

  return (
    <Alert
      className="prioritization-info-text"
      severity="info"
      icon={<LockOutlinedIcon color="primary" />}
      sx={{
        ".MuiAlert-message": {
          width: "100%",
        },
        width: "100%",
        boxSizing: "border-box",
      }}
      data-testid="project-locked-banner"
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        This project is locked.
        <Link
          onClick={() => goProjectPermissions()}
          variant={"body1"}
          sx={{
            cursor: "pointer",
          }}
        >
          OPEN PROJECT PERMISSIONS
        </Link>
      </Stack>
    </Alert>
  );
}
